import { ChartTooltip } from "@similarweb/ui-components";

import type { Translate } from "app/filters/i18nFilter";

interface ITooltipData {
    label: {
        value: string;
        color: string;
    };
    value: string;
}

export const getColumnDefinition = (translate: Translate) => [
    {
        align: "left",
        key: "website",
        selector: "label" as const,
        size: "121px",
        title: translate("bt.report.channels.me-vs-competitors-chart.chart-tooltip.columns.website.title"),
        render: ({ label }: ITooltipData) => (
            <ChartTooltip.LabelCell
                label={label.value}
                backgroundColor={label.color}
            />
        ),
    },
    {
        align: "right",
        key: "trafficShare",
        selector: "value" as const,
        size: "131px",
        title: translate("bt.report.channels.me-vs-competitors-chart.chart-tooltip.columns.traffic-share.title"),
        render: ({ value }: ITooltipData) => <ChartTooltip.ValueCell value={value} />,
    },
];
